import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@biletix/core/models/api-response";
import { TFFClubDto } from "@biletix/core/models/tff/TFFClubDto";
import { ApiService } from "@biletix/core/services/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class TFFStructureService {

  private tffBasePath: string = "/api/v1/tff/structure";

  constructor(private http: HttpClient,
              private apiService: ApiService) {
  }

  getClubList(): Observable<TFFClubDto[]> {
    return this.http
      .get<ApiResponse<TFFClubDto[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/club/list`)
      .pipe(map(response => response.data))
  }

}

